(ns ui.javascript-utils)

(defn array-reverse
  [^js/Array js-array]
  (.reverse js-array))

(defn array-concat
  [^js/Array js-array-1 ^js/Array js-array-2]
  (.concat js-array-1 js-array-2))

(defn array-sort
  [^js/Array js-array compare-fn]
  (.sort js-array compare-fn))

(defn array-push
  [^js/Array js-array item]
  (.push js-array item))

(defn array-length
  [^js/Array js-array]
  (.-length js-array))

